import React, { useState } from 'react';
import { Navigate } from "react-router-dom";
import Grid from '@mui/material/Grid2';

import RollableTableInput from "@dndComponents/other/RollableTableInput";
import { ModelBase } from '@models';

interface Props {
  obj?: ModelBase;
}

export default function RollableTableEdit({ obj }: Props) {
  const [navigateTo, setNavigateTo] = useState<string | null>(null);
  
  if (navigateTo !== null) {
    return <Navigate to={navigateTo} />;
  } else { 
    return (
      <Grid container spacing={0} direction="column">
        <RollableTableInput
          rollable_table_id={obj ? obj._id : ""}
          height={110}
          onChange={() => {
            setNavigateTo("/rollable_table");
          }}
          onCancel={() => {
            setNavigateTo("/rollable_table");
          }}
        />
      </Grid>
    );
  }
}